import { render, staticRenderFns } from "./subscription3.vue?vue&type=template&id=63a8a50c&scoped=true"
import script from "./subscription3.vue?vue&type=script&lang=js"
export * from "./subscription3.vue?vue&type=script&lang=js"
import style0 from "./subscription3.vue?vue&type=style&index=0&id=63a8a50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8a50c",
  null
  
)

export default component.exports